import { createEvent } from 'effector';

export const setInvestmentsStartDataEv = createEvent();

export const resetInvestmentsFilteredStoreEv = createEvent();
